import { render, staticRenderFns } from "./LandingCommunicationAutomatisee.vue?vue&type=template&id=1fb046ac&scoped=true"
import script from "./LandingCommunicationAutomatisee.vue?vue&type=script&lang=js"
export * from "./LandingCommunicationAutomatisee.vue?vue&type=script&lang=js"
import style0 from "./LandingCommunicationAutomatisee.vue?vue&type=style&index=0&id=1fb046ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb046ac",
  null
  
)

export default component.exports